import { createInertiaApp } from '@inertiajs/react'
import DocumentLayout from '@/components/DocumentLayout'

// The privacy policy gets the reading-column DocumentLayout. Every other page
// brings its own frame and gets none: the landing page (which sign in and sign
// up open over as a dialog) its top bar and footer, the onboarding
// OnboardingFrame, the password reset pages DeskFrame, and every signed-in
// page AppPage (AppHeader over the page's column).
const DOCUMENT_PAGES = /^privacy\//

const layoutFor = (name: string) => (DOCUMENT_PAGES.test(name) ? DocumentLayout : null)

// Controllers pick the page by name: `render inertia: "players/index"`.
void createInertiaApp({
  pages: '../pages',
  layout: layoutFor,
  title: (title) => (title ? `${title} · Fantasy Call Sheet` : 'Fantasy Call Sheet'),
  strictMode: true,
  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => ({ queryStringArrayFormat: 'brackets' }),
  },
})
